import React from 'react';
import classNames from 'classnames/bind';
import axios from 'axios';
import PropTypes from 'prop-types';

import { browserReliableDetection } from 'utils/browserReliableDetection';
import { DataBlocks, Heading, I18n, Status } from 'components';
import { connect } from 'react-redux';
import UpdateDataFromEsia from '../../components/UpdateDataFromEsia';
import UpdateDataFromPassport from './components/UpdateDataFromPassport';
import UpdateDataFromOffice from './components/Office';

// Styles
import styles from './styles.pcss';

import { selectIsCommonModalOpened, selectIsModalOpened } from './selectors';
import ModalEsiaContainer from './components/ModalEsiaContainer';
import { REQUIRED_ACTIONS_STATUSES } from './constants';

const cx = classNames.bind(styles);

const getImgSrc = (name) => `//static.beeline.ru/upload/images/b2c/selfReg/preview/${name}.svg`;

class PassportUpload extends React.Component {
  fileNames = ['passport', 'registration', 'earlyPassports'];

  previewElements = {};

  constructor(props) {
    super(props);

    this.isIE = browserReliableDetection() === 'IE';
    this.state = {
      uploadState: null,
      files: {},
      largeFiles: {},
    };
  }

  onFileChange = (name) => (file, error) => {
    this.setState((prevState) => ({
      files: {
        ...prevState.files,
        [name]: file,
      },
      largeFiles: {
        ...prevState.largeFiles,
        [name]: error === 'tooLarge',
      },
    }));
  };

  onUploadSubmit = async () => {
    const { files, largeFiles } = this.state;

    if (!files.passport || !files.registration || largeFiles.passport || largeFiles.registration) {
      return this.setState({ uploadState: 'uploadError' });
    }

    this.setState({ uploadState: 'loading' });

    const formData = new FormData();
    this.fileNames.forEach((name) => {
      formData.append(name, files[name]);
    });

    try {
      const resp = await axios.post('/api/profile/userInfo/personalData/', formData);
      if (!resp.data.isSucceeded) {
        throw new Error('server error');
      }
      this.setState({ uploadState: 'success' });
    } catch (err) {
      this.setState({ uploadState: 'serverError' });
    }
  };

  render() {
    const { uploadState, files, largeFiles } = this.state;
    const { options, message } = this.props.data.b2cUpdate;
    const { requiredAction } = this.props.data;
    const { isModalOpened, isCommonModalOpened } = this.props;

    return (
      <>
        {(isModalOpened || isCommonModalOpened) && (
          <ModalEsiaContainer />
        )}

        <DataBlocks.Container>
          <DataBlocks.Block title={<I18n path="settings.passportUpload.title" />}>
            {message && (
            <Status className={[cx('statusWarning'), 'error']}>
              <span dangerouslySetInnerHTML={{ __html: message }} />
            </Status>
            )}
            <Heading level={4}>
              <I18n path={
        (requiredAction === REQUIRED_ACTIONS_STATUSES.RENEW || requiredAction === REQUIRED_ACTIONS_STATUSES.CONFIRM)
          ? 'settings.passportUpload.headingRequiredActionConfirm'
          : 'settings.passportUpload.headingRequiredActionNone'
      }
              />
            </Heading>

            {options?.length > 0 ? options?.map((block) => {
              switch (block) {
                case 'passport':
                  return (
                    <div className={cx('caseWrap')} id="esia">
                      <UpdateDataFromPassport
                        fileNames={this.fileNames}
                        getImgSrc={getImgSrc}
                        previewElements={this.previewElements}
                        onFileChange={this.onFileChange}
                        uploadState={uploadState}
                        files={files}
                        largeFiles={largeFiles}
                        onUploadSubmit={this.onUploadSubmit}
                      />
                    </div>
                  );
                case 'esia':
                  return (
                    <div className={cx('caseWrap')} id="esia">
                      <UpdateDataFromEsia
                        requiredAction={requiredAction}
                        esiaDataUrl="/api/profile/userInfo/esiaOnceUrl/"
                      />
                    </div>
                  );
                case 'office':
                  return (
                    <div className={cx('caseWrap')} id="office">
                      <UpdateDataFromOffice />
                    </div>
                  );
              }
            }) : (
              <>
                <div className={cx('caseWrap')} id="esia">
                  <UpdateDataFromPassport
                    fileNames={this.fileNames}
                    getImgSrc={getImgSrc}
                    previewElements={this.previewElements}
                    onFileChange={this.onFileChange}
                    uploadState={uploadState}
                    files={files}
                    largeFiles={largeFiles}
                    onUploadSubmit={this.onUploadSubmit}
                  />
                </div>
                <div className={cx('caseWrap')} id="esia">
                  <UpdateDataFromEsia
                    requiredAction={requiredAction}
                    esiaDataUrl="/api/profile/userInfo/esiaOnceUrl/"
                  />
                </div>
                <div className={cx('caseWrap')} id="office">
                  <UpdateDataFromOffice />
                </div>
              </>
    )}
          </DataBlocks.Block>
        </DataBlocks.Container>
      </>

    );
  }
}

PassportUpload.propTypes = {
  options: PropTypes.array,
  message: PropTypes.string,
  isModalOpened: PropTypes.bool,
  isCommonModalOpened: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  isModalOpened: selectIsModalOpened(state),
  isCommonModalOpened: selectIsCommonModalOpened(state),
});

export default connect(mapStateToProps)(PassportUpload);
